import { styled } from '../../theme'

export const Wrapper = styled.div`
  position: relative;
  height: 30px;
  overflow: hidden;
  z-index: 50;
`
export const Shadow = styled.div`
  position: absolute;
  width: 100%;
  height: 30px;
  left: 0;
  bottom: 30px;

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
    top: 50%;
    bottom: 0;
    left: 5px;
    right: 5px;
    border-radius: 100px / 10px;
  }

  &::after {
    content: '';
    position: absolute;
    z-index: -1;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
    top: 50%;
    bottom: 0;
    left: 5px;
    right: 5px;
    border-radius: 100px / 10px;
  }
`
